import { cn } from '@/lib/utils/cn';
import { QuestionWrapper } from './question-wrapper';
import type { QuestionComponentProps } from '@/types';

export function NPS({
  question,
  value,
  onChange,
  disabled,
  errors,
}: QuestionComponentProps<number | null>) {
  const minLabel = question.config?.minLabel || 'Not at all likely';
  const maxLabel = question.config?.maxLabel || 'Extremely likely';

  const handleSelect = (score: number) => {
    if (disabled) return;
    onChange(score);
  };

  return (
    <QuestionWrapper question={question} errors={errors}>
      {/* NPS Scale */}
      <div className="space-y-4">
        <div className="flex flex-wrap justify-center gap-2 sm:gap-3">
          {Array.from({ length: 11 }, (_, i) => (
            <button
              key={i}
              type="button"
              onClick={() => handleSelect(i)}
              disabled={disabled}
              className={cn(
                'flex h-10 w-10 sm:h-12 sm:w-12 items-center justify-center rounded-lg border-2 text-sm font-medium transition-colors',
                value === i
                  ? 'border-primary-600 bg-primary-600 text-white'
                  : 'border-gray-300 bg-white text-gray-700 hover:border-primary-300 hover:bg-primary-50',
                disabled && 'opacity-50 cursor-not-allowed'
              )}
            >
              {i}
            </button>
          ))}
        </div>

        {/* Labels */}
        <div className="flex justify-between text-xs text-gray-500 px-1">
          <span>{minLabel}</span>
          <span>{maxLabel}</span>
        </div>
      </div>
    </QuestionWrapper>
  );
}
